module.exports = __webpack_public_path__ + "img/banner.b23efe12.jpg";